import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, Button, Container, DropdownMenuItem } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const HeadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 1rem;

  & > :nth-child(2) {
    margin-left: auto;
  }
  & > :nth-child(3) {
    margin-left: 1rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 1rem;
    align-items: flex-start;
    flex-wrap: wrap;
    & > :nth-child(3) {
      margin-left: 0;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
    & > :nth-child(2) {
      margin-left: 0;
    }
    & > :nth-child(3) {
      margin-top: 0;
      margin-left: 0;
    }
  }
`;

export const StyledHeading = styled.span`
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;
  font-size: 2.3rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  padding-top: 1.875rem;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
  & > :nth-child(3) {
    margin-top: 0;
    padding-right: 0;
    margin-right: -1rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    margin-inline: 0;
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledIcon = styled.div`
  margin-top: 0.4rem;
  display: inline-block;
  vertical-align: middle;
`;

export const Wrapper = styled.div`
  display: grid;
  align-items: center;
  margin: 5rem 1rem 1rem;
  grid-template-columns: 1fr auto;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
  }
`;

export const StyledNoRecordMessage = styled.p`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey[900]};
  justify-content: center;
`;

export const StyledText = styled.div`
  display: grid;
  justify-content: flex-start;
  width: 100%;
  text-align: left;
  margin-bottom: 6rem;
  color: ${({ theme }) => theme.colors.paragraph};

  span {
    color: ${({ theme }) => theme.colors.info.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: center;
  }
`;

export const StyledButton = styled(Button)`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  padding: 1rem;
  height: 3.4rem;
  transition: color 0.2s ease-in-out;

  &:hover:not(:disabled) {
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};

    svg {
      transition: fill 0.2s ease-in-out;
      color: ${({ theme }) => theme.colors.info.main};
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.grey[600]};
    transition: fill 0.2s ease-in-out;
  }
`;

export const PagginationWrapper = styled(Wrapper)`
  margin-top: 0;
`;

export const StyledPagination = styled.div`
  display: grid;
  justify-content: flex-end;
  margin-top: 0;
  margin-bottom: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-row: 2;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.xl}) {
    justify-content: center;
  }
`;

export const StyledFilters = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr;
  column-gap: 0.5rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    row-gap: 0.5rem;
    text-align: left;
  }
`;

export const StyledSearch = styled.div`
  flex: 1;
  text-align: left;
  svg {
    color: ${({ theme }) => theme.colors.grey[700]};
  }
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 25rem;
  }
`;

export const StyledDropDown = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
    justify-content: flex-start;
  }
`;

export const StyledSize = styled.span`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledLimitSelect = styled.div`
  margin-right: 1rem;
  margin-left: 1rem;
  display: inline-block;
  vertical-align: middle;
  max-width: 8rem;
  width: 100%;
  text-align: left;
`;

export const StyledSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 25rem;
  text-align: left;
`;

export const StyledDivider = styled.div`
  border-top: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
  margin-block: 1rem;
`;

export const StyledHeadingIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledDateTimePicker = styled.div`
  position: relative;
  & > div[role='tooltip'] {
    position: absolute;
    z-index: 1;
    top: -5rem;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  &:hover {
    & > div[role='tooltip'] {
      visibility: visible;
      opacity: 1;
    }
  }
  .react-datepicker-wrapper .react-datepicker__input-container {
    .cyoBmk {
      border: none;
      background-color: transparent;
    }
  }
`;

export const StyledTooltipText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  line-height: 1.5rem;
`;

export const StyledBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

export const StyledTesterContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  display: flex;
  height: 3.4rem;
  padding: 0.7rem 1rem;
  align-items: center;
  align-self: stretch;
`;

export const StyledTriggerElement = styled.p`
  width: 100%;
`;

export const StyledBanner = styled(Banner)`
  height: 23.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    height: 35rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    height: 25rem;
  }
`;
